import React from 'react';
import { format, isBefore, parseISO } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import { getEntityUrl } from '@culture/common-helpers/cultureUtils';

import ShowOnlyClient from 'components/ShowOnlyClient';

import CommonPropTypes from 'utils/propTypes/common';

import BasePreview from '../BasePreview';

import styles from './styles.module.scss';

const BroadcastPreview = ({ data, ...props }) => {
	const { shortText, institute } = data;
	const publishDate = parseISO(data.publishDate);
	const broadcastUrl = getEntityUrl('broadcast', data);
	const instituteUrl =
		institute?.status === 'published'
			? getEntityUrl('institutes', institute)
			: null;

	return (
		<BasePreview
			data={data}
			url={broadcastUrl}
			subtitle={shortText && <div className={styles.text}>{shortText}</div>}
			footer={
				<div>
					{institute && (
						<span className={styles.item}>
							{instituteUrl ? (
								<a className={styles.link} href={instituteUrl}>
									{institute.title}
								</a>
							) : (
								institute.title
							)}
						</span>
					)}
					<ShowOnlyClient>
						<div className={styles.item}>
							<span className={styles.attribute}>
								{format(publishDate, 'd MMMM yyyy', { locale: ruLocale })}
							</span>
							{isBefore(new Date(), publishDate) && (
								<span className={styles.attribute}>
									{format(publishDate, 'EEEEEE HH:mm', { locale: ruLocale })}
								</span>
							)}
						</div>
					</ShowOnlyClient>
				</div>
			}
			{...props}
		/>
	);
};

BroadcastPreview.propTypes = {
	data: CommonPropTypes.entity.isRequired
};

export default BroadcastPreview;
